import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { isMobile } from "react-device-detect";
import cache from "memory-cache";
import moment from "moment";

import getOrderStatus from "../../../lib/getOrderStatus";

import Api from "../../../lib/componentApi";
import Loading from "../../Common/Loading";
import OrderDetailHead from "./components/Detail/OrderDetailHead";
import AddressInformation from "./components/Detail/AddressInformation";
import BonusSection from "./components/Detail/BonusSection";
import TotalSection from "./components/Detail/TotalSection";
import ItemsDetail from "./components/Detail/ItemsDetail";
import ButtonSection from "./components/Detail/ButtonSection";

class Detail extends Component {
  constructor(props) {
    super(props);
    let mobile;
    //eslint-disable-next-line
    if (__isBrowser__) {
      mobile = isMobile;
    } else {
      mobile = cache.get("deviceType");
    }
    this.state = {
      order: null,
      statusText: null,
      mobile,
      orderUid: props.orderUid
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.orderUid && nextProps.orderUid !== prevState.orderUid) {
      location.reload(true);
      return {
        orderUid: nextProps.orderUid
      };
    }
    return null;
  }
  componentDidMount() {
    const { orderUid } = this.state;
    Api.post("/api/order", { orderUid }, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log(response, "code-order");
      } else {
        if (response.status) {
          this.setState({
            order: response,
            statusText: getOrderStatus(response.status, response.deliveryType)
          });
        }
      }
    });
  }
  handleClickDirections = (lat, lon) => {
    window.location.href = `https://www.google.com/maps/@${lat},${lon},12z`;
  };
  getDirections = (status, mobile, delivery) => {
    return mobile && !delivery && status === "ORDER_PREPARED";
  };
  render() {
    const { order, statusText, orderUid, mobile } = this.state;
    const {
      onClickClose,
      handleRateOrder,
      handleReOrder,
      handleTipOrder
    } = this.props;
    const {
      restaurant,
      orderDate,
      deliveryType,
      address,
      total,
      subTotal,
      earnedPoints,
      deliveryFee,
      items,
      review,
      orderCompletedRewardPoints,
      refund,
      totalPromoCodeAmount,
      deliveryDriver,
      status
    } = order || "";
    let multiplePointsEarned = false;
    if ((review && review.pointsEarned) || orderCompletedRewardPoints) {
      multiplePointsEarned = true;
    }
    const delivery = deliveryType === "DELIVERY";
    const directions = this.getDirections(status, mobile, delivery);
    const formattedDate = moment
      .utc(orderDate)
      .local()
      .format("MMMM DD, YYYY HH:mm");
    return (
      <div>
        {/* Header */}
        <div className="head-general with-back visible-xs">
          <a
            href="javascript: void(0)"
            className="back"
            onClick={() => onClickClose("orderSection")}
          >
            <img src="/png/chevron-left.png" />
          </a>
          <h4>Order #{orderUid}</h4>
          <a href="javascript: void(0)" className="close" />
        </div>
        {/* Header */}
        {(order && (
          <React.Fragment>
            <div className="order-detail">
              <OrderDetailHead
                statusText={statusText}
                restaurant={restaurant}
                formattedDate={formattedDate}
                order={order}
                orderUid={orderUid}
              />
              {/* .status */}
              <div className="container">
                <div className="row center-sm">
                  <div className="col-sm-12">
                    <AddressInformation
                      directions={directions}
                      handleClickDirections={this.handleClickDirections}
                      restaurant={restaurant}
                      delivery={delivery}
                      address={address}
                      orderUid={order.uid}
                      restaurantDeliveryType={order.restaurantDeliveryType}
                      orderStatus={order.status}
                    />

                    <div className="p-section">
                      <BonusSection
                        multiplePointsEarned={multiplePointsEarned}
                        earnedPoints={earnedPoints}
                        review={review}
                        orderCompletedRewardPoints={orderCompletedRewardPoints}
                      />
                      <TotalSection
                        order={order}
                        total={total}
                        refund={refund}
                        totalPromoCodeAmount={totalPromoCodeAmount}
                        deliveryFee={deliveryFee}
                        subTotal={subTotal}
                      />

                      <ItemsDetail items={items} />
                      {/* .restaurant-detail */}

                      <ButtonSection
                        order={order}
                        handleRateOrder={handleRateOrder}
                        handleReOrder={handleReOrder}
                        handleTipOrder={handleTipOrder}
                        orderUid={orderUid}
                        deliveryDriver={deliveryDriver}
                        restaurantDeliveryType={order.restaurantDeliveryType}
                      />
                    </div>
                  </div>
                  {/* .col-sm-8 */}
                </div>
                {/* .row */}
              </div>
              {/* .container */}
            </div>
            {/* .order-detail */}
          </React.Fragment>
        )) || <Loading />}
      </div>
    );
  }
}

export default withRouter(Detail);
